module.exports = __webpack_public_path__ + "static/image-meta-b17270a1ca804f5414e3f3a4108738b0.jpg";